import { render, staticRenderFns } from "./lclSearchBar.vue?vue&type=template&id=28d32a27&scoped=true&"
import script from "./lclSearchBar.vue?vue&type=script&lang=js&"
export * from "./lclSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d32a27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d32a27')) {
      api.createRecord('28d32a27', component.options)
    } else {
      api.reload('28d32a27', component.options)
    }
    module.hot.accept("./lclSearchBar.vue?vue&type=template&id=28d32a27&scoped=true&", function () {
      api.rerender('28d32a27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/lclSearchBar.vue"
export default component.exports